module.exports = __webpack_public_path__ + "img/icon_delete_emt.47c18abf.png";